import { render } from "./product-attachment-options.vue?vue&type=template&id=06ca9604"
import script from "./product-attachment-options.vue?vue&type=script&lang=js"
export * from "./product-attachment-options.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__